import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MenuItem } from '@components';
import { PfImage } from '@profabric/react-components';
import styled from 'styled-components';
import { SidebarSearch } from '@app/components/sidebar-search/SidebarSearch';
import { checkPermissions } from '../../../services/check_auth';
export interface IMenuItem {
  name: string;
  icon?: string;
  path?: string;
  children?: Array<IMenuItem>;
}

export const MENU: IMenuItem[] = [
  {
    name: 'Portals',
    icon: 'fas fa-home common_ico',
    path: '/'
  },
  {
    name: 'Manage Users',
    icon: 'fas fa-user common_ico',
    path: '/users'
  },
  {
    name: 'Audit Log',
    icon: 'fas fa-clipboard-list common_ico',
    path: '/audit-log'
  },
  {
    name: 'Api Log',
    icon: 'fas fa-exclamation-circle common_ico',
    path: '/api-log'
  },
  {
    name: 'Manage Setting',
    icon: 'fas fa-cog common_ico',
    path: '/setting'
  }
];


const StyledUserImage = styled(PfImage)`
  --pf-box-shadow: 0 3px 6px #00000029, 0 3px 6px #0000003b !important;
`;

const MenuSidebar = () => {
  const user = useSelector((state: any) => state.auth.currentUser);
  const sidebarSkin = useSelector((state: any) => state.ui.sidebarSkin);
  const menuItemFlat = useSelector((state: any) => state.ui.menuItemFlat);
  const menuChildIndent = useSelector((state: any) => state.ui.menuChildIndent);

  return (
    <aside className={`main-sidebar elevation-4 ${sidebarSkin}`}>
      <Link to="/" className="brand-link">
        <span><img src="/img/logo.svg" className="mr-4" alt='logo' width={160} height={45} /></span>
      </Link>
      <div className="sidebar">
        <div className="user-panel d-flex">
          <div className="image">
            <StyledUserImage
              src={user.picture}
              fallbackSrc="/img/person-icon.svg"
              alt="User"
              width={34}
              height={34}
              rounded
            />
          </div>
          <div className="info">
            <Link to="/profile" className="d-block">
              <span className='adminName'>{user.name ?? 'Admin'}</span>
              <br />
              Manager
            </Link>
          </div>
        </div>

        <div className="form-inline mt-2">
          <SidebarSearch />
        </div>

        <nav className="mt-2">
          <ul
            className={`nav nav-pills nav-sidebar flex-column${menuItemFlat ? ' nav-flat' : ''
              }${menuChildIndent ? ' nav-child-indent' : ''}`}
            role="menu"
          >
            {MENU.map((menuItem: IMenuItem) => (
              <React.Fragment key={menuItem.name + menuItem.path}>
                <MenuItem menuItem={menuItem}
                />
              </React.Fragment>
            ))}

          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default MenuSidebar;
